/* eslint-disable import/first */
import React from 'react';
import { useIntl } from 'react-intl';
import compact from 'lodash/compact';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
import 'react-lazy-load-image-component/src/effects/blur.css';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import { Button } from '@material-ui/core';
const { selectCategoryEntities } = Slices.categorySlice;
import MediaGridList from './MediaGridList';
import { BiRightArrowCircle } from '@react-icons/all-files/bi/BiRightArrowCircle';
import { BiLeftArrowCircle } from '@react-icons/all-files/bi/BiLeftArrowCircle';
import MediaGridListDesktop from './MediaGridListDesktop';
import SwipeableViews from 'react-swipeable-views';
import css from './index.module.scss';

export default function MediaGrid({ widgetData }) {
  const categories = useSelector(selectCategoryEntities);
  const isDesktop = useSelector(selectDesktop);
  const [currentSlider, setCurrentSlider] = React.useState(0);
  const intl = useIntl();
  const axis = intl.locale === 'ar' ? 'x-reverse' : 'x';
  const maxSteps = widgetData.media.length;
  const handleNext = () => {
    if (maxSteps !== currentSlider + 3) {
      setCurrentSlider((prv) => prv + 1);
    }
  };

  const handleBack = () => {
    if (currentSlider !== 0) {
      setCurrentSlider((prv) => prv - 1);
    }
  };

  // eslint:fix map is replaced with forEach
  const sortedExploreTiles = compact(
    widgetData.media.map((media) => {
      const categoryVal = categories[media.action.id];
      if (media.action && media.action.type === 'category' && categoryVal) {
        return media;
      }
    })
  );

  return (
    <>
      {Object.keys(categories) && (
        <div className={css.root}>
          {!isDesktop &&
            widgetData.media.map((media, i) => {
              if (media.action && media.action.type === 'category') {
                const targetPath = generateCategoryRoute({
                  category: categories[media.action.id],
                  locale: intl.locale,
                });

                return <MediaGridList targetPath={targetPath} media={media} key={i} />;
              }
              return '';
            })}

          {isDesktop && (
            <>
              <SwipeableViews
                axis={axis}
                enableMouseEvents={true}
                slideClassName={css.blockItem}
                className={css.mediaContainer}
                index={currentSlider}
                onChangeIndex={setCurrentSlider}
                // nextButton={
                //   <Button size="small" onClick={handleNext} disabled={currentSlider === maxSteps - 1}>
                //     Next
                //   </Button>
                // }
                // backButton={
                //   <Button size="small" onClick={handleBack} disabled={currentSlider === 0}>
                //     Back
                //   </Button>
                // }
              >
                {sortedExploreTiles.map((media, i) => {
                  if (media.action && media.action.type === 'category') {
                    const targetPath = generateCategoryRoute({
                      category: categories[media.action.id],
                      locale: intl.locale,
                    });
                    const gridClass = 'gridList' + i;
                    return (
                      <MediaGridListDesktop
                        className={gridClass}
                        targetPath={targetPath}
                        media={media}
                        key={i}
                      />
                    );
                  }
                })}
              </SwipeableViews>
            </>
          )}
          <div className={css.pagination}>
            <Button disabled={maxSteps === currentSlider + 3} onClick={handleNext}>
              <BiRightArrowCircle />
            </Button>
            <Button disabled={currentSlider === 0} onClick={handleBack}>
              <BiLeftArrowCircle />
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
